module.exports = __webpack_public_path__ + "img/puesta-en-valor-2-zoom.0f63b4a7.jpg";